import React from "react";

const Education = () => (
    <div className="row education">
	<div className="three columns header-col">
	    <h1>
		<span>Education</span>
	    </h1>
	</div>
	
	<div className="nine columns main-col">
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">New York University, MA</h4>
	          <p className="info">
	    	English Education: Teachers of English Language &amp; Literature in Colleges
	            <span>&bull;</span>
	    	Present
	          </p>
	          <p></p>
	        </div>
	      </div>	
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">Brooklyn College, MFA</h4>
	          <p className="info">
	    	Creative Writing: Poetry
	            <span>&bull;</span>
	    	2011
	          </p>
	          <p></p>
	        </div>
	      </div>	
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">Boston University, BA</h4>
	          <p className="info">
	    	English with Computer Science minor
	            <span>&bull;</span>
	    	2007
	          </p>
	          <p></p>
	        </div>
	      </div>	
        </div>
    </div>
);

export default Education;



// WEBPACK FOOTER //
// ./src/components/resume/Education.jsx